import { APP_CONSTANTS } from 'utils/constants'

const toTypesSelectData = types =>
  types.map(type => ({
    value: type.id,
    label: type.name
  }))

const toSizeSelectData = size => ({
  label: APP_CONSTANTS.CompanySize[size],
  value: size
})

const toSegment = segment => ({
  label: segment?.name,
  value: segment?.id
})

export const toEditCompanyData = company => {
  const { types, size, segment } = company

  return {
    ...company,
    types: toTypesSelectData(types),
    size: toSizeSelectData(size),
    segment: segment && toSegment(segment)
  }
}

export const toGroupOptions = (contacts, companyName) => [
  {
    label: companyName,
    options: contacts.map(c => ({
      label: `${c.firstName} ${c.lastName}`,
      value: c.id
    }))
  }
]

export const toFormData = (contactId, files, note, companyId, dateEntered) => {
  const formData = new FormData()
  formData.append('contactId', contactId)
  formData.append('companyId', companyId)
  formData.append('note', note)
  formData.append('dateEntered', dateEntered)
  files.forEach(file => {
    if (!file.id) {
      formData.append('newAttachments', file)
    } else {
      formData.append('attachmentIds', file.id)
    }
  })

  return formData
}
